/**
 * orga-app-api - veranstaltungstypen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VeranstaltungsTypenProblemTypes = {
    VerTypFunktionsbereichNichtGefunden: 'VerTypFunktionsbereichNichtGefunden',
    VerTypBereitsAngelegt: 'VerTypBereitsAngelegt',
    VerTypFunktionsbereichGeloescht: 'VerTypFunktionsbereichGeloescht',
    VerTypKeinAdminOderVerTypAdmin: 'VerTypKeinAdminOderVerTypAdmin',
    VerTypKeinTypAdmin: 'VerTypKeinTypAdmin',
    VerTypIdFehlt: 'VerTypIdFehlt'
} as const;
export type VeranstaltungsTypenProblemTypes = typeof VeranstaltungsTypenProblemTypes[keyof typeof VeranstaltungsTypenProblemTypes];

